import { lazy } from 'react';
import { APP_PATHS } from '../paths';
import { RouteConfig } from '../types';

const OnboardingJobSearch = lazy(
  () => import('../../views/onboarding/OnboardingJobSearch')
);
const OnboardingJobDescription = lazy(
  () => import('../../views/onboarding/OnboardingJobDescription')
);
const OnboardingFeedback = lazy(
  () => import('../../views/onboarding/OnboardingFeedback')
);
const OnboardingResult = lazy(
  () => import('../../views/onboarding/OnboardingResult')
);

export const onboardingRoutes: RouteConfig[] = [
  {
    path: APP_PATHS.onboardingJobSearch,
    element: <OnboardingJobSearch />,
  },
  {
    path: APP_PATHS.onboardingJobDescription,
    element: <OnboardingJobDescription />,
  },
  {
    path: APP_PATHS.onboardingFeedback,
    element: <OnboardingFeedback />,
  },
  {
    path: APP_PATHS.onboardingResult,
    element: <OnboardingResult />,
  },
];
